import { GTMMaterialType } from '@/fo/api/gtm';
import { GetBlogPostsQuery } from '@/fo/api/magento';
import { ArticleBanner } from '@/fo/ui/article/banner/blog';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { urlMap } from '../consts';
import { BlogPageType } from '../types';

const materialTypeMap: Record<BlogPageType, GTMMaterialType> = {
  [BlogPageType.Article]: 'article',
  [BlogPageType.News]: 'news',
  [BlogPageType.Video]: 'video'
};

export const mapPostsToBanner = (
  posts: GetBlogPostsQuery['mpBlogPosts'],
  type: BlogPageType
) => {
  const mappedPosts: ArticleBanner[] =
    posts?.items
      ?.filter((item) => item !== null)
      .map((post) => {
        if (!post.post_id || !post.name || !post.url_key) {
          return null;
        }

        return {
          id: post.post_id.toString(),
          title: post.name,
          materialType: materialTypeMap[type],
          withDoctor: post.with_doctor ?? false,
          tags:
            post.categories?.items
              ?.filter((category) => category !== null)
              .map((category) => {
                if (!category.name || !category.url_key) {
                  return null;
                }

                return {
                  id: category.url_key,
                  title: category.name,
                  color: category.color ?? undefined,
                  href: `/about-skin/${urlMap[type]}/categories/${category.url_key}`
                };
              })
              .filter((item) => item !== null) ?? [],
          imageUrl: post.image
            ? '/' + post.image
            : staticMediaUrl('blog/placeholder.png'),
          mobileImageUrl: post.small_image
            ? '/' + post.small_image
            : staticMediaUrl('blog/placeholder.png'),
          imageAlt: post.name,
          articleUrl: `/about-skin/${urlMap[type]}/${post.url_key}`
        };
      })
      .filter((item) => item !== null) ?? [];

  return mappedPosts;
};
